module.exports = __webpack_public_path__ + "static/design-35e3350faf0b820c9513e73552dd3ad3.png";